import { Typography } from "@mui/material";
import MButton from "components/shared/MButton";
import posthog, { captureFailure, isPostHogEnabled } from "posthog";
import { Component, ReactNode } from "react";

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

// Uses the theme above it, so inside Caas it matches the client's theme
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    if (isPostHogEnabled) {
      posthog.captureException(error, { source: "error_boundary" });
    }
    captureFailure("app_crashed", { error: error.name });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          padding: 24,
          boxSizing: "border-box",
          textAlign: "center",
        }}
      >
        <Typography variant="h6">Something went wrong</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Please try again.
        </Typography>
        <MButton
          text="Refresh"
          onPress={() => window.location.reload()}
          outlineButton={false}
        />
      </div>
    );
  }
}
